import { render, staticRenderFns } from "./parts-order-details.vue?vue&type=template&id=35935104&scoped=true"
import script from "./parts-order-details.vue?vue&type=script&lang=js"
export * from "./parts-order-details.vue?vue&type=script&lang=js"
import style0 from "./parts-order-details.vue?vue&type=style&index=0&id=35935104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35935104",
  null
  
)

export default component.exports